module.exports = __webpack_public_path__ + "static/media/hydroponics_systems_net_pots3.d935c725.webp";